export default __webpack_public_path__ + "static/media/developer-diego.14e424b5.png";